'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var React = require('react');

require('../Article/Article.js');

require('../ArticleInfoBlock/ArticleInfoBlock.js');

require('../ArticleList/ArticleList.js');

require('../ArticleList/ArticleListItemImage/ArticleListItemImage.js');

require('../BreadCrumbs/BreadCrumbs.js');

require('../ContentBody/ContentBody.js');

require('../ContentIntroduction/ContentIntroduction.js');

require('../ContentTitle/ContentTitle.js');

require('../PageHeader/PageHeader.js');

require('../Pagination/Pagination.js');

var Section = require('../Section/Section.js');

require('../Section/SectionHeader/SectionHeader.js');

require('../SideBar/SideBar.js');

require('../SideBar/ContactsBlock/ContactsBlock.js');

require('../SideBar/ListBlock/ListBlock.js');

require('../SideBar/ListenBlock/ListenBlock.js');

require('../SideBar/MediaContactBlock/MediaContactBlock.js');

require('../SideBar/SearchBlock/SearchBlock.js');

require('../SideBar/SocialBlock/SocialBlock.js');

require('../SideBar/TopicBlock/TopicBlock.js');

var Button = require('../../primitives/Button/Button.js');

var index = require('../../node_modules/prop-types/index.js');

function _interopDefault(e) {
  return e && e.__esModule ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefault(React);

var NewsletterSubscription = function NewsletterSubscription(_ref) {
  var backgroundColor = _ref.backgroundColor;
  return /*#__PURE__*/React__default['default'].createElement(Section.Section, {
    backgroundColor: backgroundColor,
    className: "newsletter-subscription"
  }, /*#__PURE__*/React__default['default'].createElement("h4", {
    className: "newsletter-subscription-title"
  }, "Subscribe to our Newsletter"), /*#__PURE__*/React__default['default'].createElement("p", {
    className: "newsletter-subscription-description"
  }, "Sign up to receive the latest news and feature stories from Los Alamos National Laboratory"), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "newsletter-subscription-controls"
  }, /*#__PURE__*/React__default['default'].createElement("input", {
    type: "text",
    placeholder: "Email address",
    className: "newsletter-subscription-input"
  }), /*#__PURE__*/React__default['default'].createElement(Button.Button, {
    className: "newsletter-subscription-button",
    onClick: function onClick() {
      window.location.replace('https://service.govdelivery.com/accounts/USLANL/subscriber/new?category_id=USLANL_C7');
    }
  }, "SIGN UP")));
};

NewsletterSubscription.defaultProps = {
  backgroundColor: '#F1EFF7'
};
NewsletterSubscription.propTypes = {
  backgroundColor: index['default'].string
};
exports.NewsletterSubscription = NewsletterSubscription;
exports['default'] = NewsletterSubscription;